import type { HTMLAttributes, TableHTMLAttributes } from "react";

type TableProps = TableHTMLAttributes<HTMLTableElement> & {
  /** 表格容器额外类名。 */
  containerClassName?: string;
  /** 内容密度，紧凑模式适合后台分页列表。 */
  density?: "default" | "compact";
  /** 是否让表头在容器滚动时保持可见。 */
  stickyHeader?: boolean;
};

/** shadcn 风格表格容器。 */
export function Table({ className = "", containerClassName = "", density = "default", stickyHeader = false, ...props }: TableProps) {
  return <div data-slot="table-container" data-density={density} data-sticky-header={stickyHeader || undefined} className={`fm-shadcn-table-wrap ${containerClassName}`.trim()}><table data-slot="table" className={`fm-shadcn-table ${className}`.trim()} {...props} /></div>;
}

/** 表头。 */
export function TableHead(props: HTMLAttributes<HTMLTableSectionElement>) { return <thead data-slot="table-header" {...props} />; }
/** 表体。 */
export function TableBody(props: HTMLAttributes<HTMLTableSectionElement>) { return <tbody data-slot="table-body" {...props} />; }
/** 表格行。 */
export function TableRow({ className = "", ...props }: HTMLAttributes<HTMLTableRowElement>) { return <tr data-slot="table-row" className={`fm-shadcn-table-row ${className}`.trim()} {...props} />; }
/** 表格单元格。 */
export function TableCell({ className = "", ...props }: HTMLAttributes<HTMLTableCellElement>) { return <td data-slot="table-cell" className={className} {...props} />; }
/** 表头单元格。 */
export function TableHeader({ className = "", ...props }: HTMLAttributes<HTMLTableCellElement>) { return <th data-slot="table-head" className={className} {...props} />; }
